import React, { useState,useEffect } from 'react';
import {
  Text,
  Flex,
  Heading,
  Card,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  VStack,
  Button,
  InputGroup,
  InputLeftElement,
  useColorMode,
} from '@chakra-ui/react';
import { ToastContainer, toast } from 'react-toastify';
import { motion } from 'framer-motion';
import { AiOutlineSend, AiOutlineUser, AiOutlineMail } from 'react-icons/ai';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from 'emailjs-com';

const ContactFormCard = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const gradientColor = `linear-gradient(135deg, #FF6B6B, #7873F5)`;

  const { colorMode } = useColorMode();
  const bgColor = colorMode === "light" ? "white" : "dark";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    // emailjs configuration
    emailjs.init('pCkxAr7kKOBqgVmsH');
    const serviceID = 'service_t2bcltu';
    const templateID = 'template_f6zyrjb';

    const templateParams = {
      name: name,
      message: message,
    };

    try {
      const response = await emailjs.send(serviceID, templateID, templateParams);
      console.log('Email sent:', response);
      toast.success('Message sent successfully!', { autoClose: 3000 });
      // Clear form fields after successful submission
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('Email error:', error);
      toast.error('Message could not be sent.');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(()=>{
    window.scrollTo(0,0);
  })

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >

    <Flex direction="column" align="center" minHeight="100vh" bgColor={bgColor} p={6}>
        {/* Colorful heading */}
        <Heading fontSize={['2xl', '4xl', '5xl']} fontFamily="Times New Roman" textAlign="center">
        <Text
              // as="span"
              bgGradient={gradientColor}
              bgClip="text"
              fontFamily={"Times New Roman"}
            >
              Contact Me
            </Text>
        </Heading>
        {/* Small paragraph */}
        <Text fontSize={['md', 'lg']} textAlign="center" color="gray.500">
          Email me at himanshugoldy24@gmail.com
        </Text>
        {/* Project components */}
        <Flex direction="column" width="100%" align="center" minHeight="90vh" justify="center">
        <Card width={['90%', '80%', '70%', '50%']} p={6} borderRadius="lg" boxShadow="md">
          <form onSubmit={handleSubmit}>
            <VStack spacing={4}>
              <FormControl>
                <FormLabel>Your Name</FormLabel>
                <InputGroup>
                  <InputLeftElement children={<AiOutlineUser />} />
                  <Input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    placeholder='Your Name'
                  />
                </InputGroup>
              </FormControl>
              <FormControl>
                <FormLabel>Your Email</FormLabel>
                <InputGroup>
                  <InputLeftElement children={<AiOutlineMail />} />
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder='Your Email'
                  />
                </InputGroup>
              </FormControl>
              <FormControl>
                <FormLabel>Message</FormLabel>
                <InputGroup>
                  <Textarea
                    rows={4}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    placeholder='Your message for me :)'
                  />
                </InputGroup>
              </FormControl>
              <Button
                type="submit"
                _hover={{ transform: 'scale(1.1)' }}
                colorScheme="purple"
                disabled={isSubmitting}
                rightIcon={<AiOutlineSend />}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </Button>
            </VStack>
          </form>
        </Card>
        <ToastContainer />
      </Flex>
      </Flex>      
    </motion.div>
  );
};

export default ContactFormCard;
